// ** React Imports
import { Fragment, useState, useRef } from 'react'

// ** Vertical Menu Items Array
import navigation from '@fwsrc/navigation/vertical'
import { Icon } from "@iconify/react"
import { _logout, getUserData } from '@authModule'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

// ** Third Party Components
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'

// ** Vertical Menu Components
import VerticalMenuHeader from './VerticalMenuHeader'
import VerticalNavMenuItems from './VerticalNavMenuItems'

const Sidebar = props => {
  // ** Props
  const { menuCollapsed, routerProps, menu, currentActiveItem, skin } = props
  const dispatch = useDispatch()
  // ** States
  const [groupOpen, setGroupOpen] = useState([])
  const [groupActive, setGroupActive] = useState([])
  const [activeItem, setActiveItem] = useState(null)
  const bottomNav = [
    {
      id: 'profile',
      title: 'Account Settings',
      icon: <Icon icon="fluent:person-settings-20-regular" width={20} height={20} />,
      navLink: '/account',
      action: 'call',
      resource: 'ARTIST_ALL_PERMISSION'
    },
    {
      id: 'security',
      // title: trans('user.nav.security'),
      title: 'Security',
      icon: <Icon icon="hugeicons:help-square" width={20} height={20} />,
      navLink: '/security',
      action: 'call',
      resource: 'EMAIL_OAUTH_TYPE'
    },
    {
      id: 'tickets',
      title: 'Help & Support',
      icon: <Icon icon="hugeicons:help-square" width={20} height={20} />,
      navLink: '/tickets',
      action: 'call',
      resource: 'ARTIST_ALL_PERMISSION'
    }

  ]
  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false)

  // ** Ref
  const shadowRef = useRef(null)

  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    if (menuCollapsed) {
      setMenuHover(true)
    }
  }

  // ** Scroll Menu
  const scrollMenu = container => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.add('d-block')
      }
    } else {
      if (shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.remove('d-block')
      }
    }
  }

  return (
    <Fragment>

      <div
        className={classnames('main-menu menu-fixed menu-accordion menu-shadow', {
          expanded: menuHover || menuCollapsed === false,
          'menu-light': skin !== 'semi-dark' && skin !== 'dark',
          'menu-dark': skin === 'semi-dark' || skin === 'dark'
        })}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => setMenuHover(false)}
      >

        {menu ? (
          menu
        ) : (
          <Fragment>
            {/* Vertical Menu Header */}

            <VerticalMenuHeader setGroupOpen={setGroupOpen} menuHover={menuHover} {...props} />
            {/* Vertical Menu Header Shadow */}
            <div className='shadow-bottom' ref={shadowRef}></div>

            {/* Perfect Scrollbar */}
            <PerfectScrollbar
              className='main-menu-content'
              options={{ wheelPropagation: false }}
              onScrollY={container => scrollMenu(container)}
            >
              <ul className='navigation navigation-main' style={{ paddingBottom: process.env.REACT_APP_AUTH_MODULE === 'artist' ? '300px' : '0px' }}>
                <VerticalNavMenuItems
                  items={navigation}
                  groupActive={groupActive}
                  setGroupActive={setGroupActive}
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                  groupOpen={groupOpen}
                  setGroupOpen={setGroupOpen}
                  routerProps={routerProps}
                  menuCollapsed={menuCollapsed}
                  menuHover={menuHover}
                  currentActiveItem={currentActiveItem}
                  setMenuVisibility={props.setMenuVisibility}
                />
              </ul>
              </PerfectScrollbar>
              {process.env.REACT_APP_AUTH_MODULE === 'artist' ? <div style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                 zIndex: '999',
                padding: '5px 0'
                
              }}> 
              <ul className='navigation navigation-main'>
                  <hr />
                  <VerticalNavMenuItems
                    items={bottomNav}
                    groupActive={groupActive}
                    setGroupActive={setGroupActive}
                    activeItem={activeItem}
                    setActiveItem={setActiveItem}
                    groupOpen={groupOpen}
                    setGroupOpen={setGroupOpen}
                    routerProps={routerProps}
                    menuCollapsed={menuCollapsed}
                    menuHover={menuHover}
                    currentActiveItem={currentActiveItem}
                    setMenuVisibility={props.setMenuVisibility}
                  />
                  <li id="add-campaign" class="nav-item">
                    <Link class="d-flex align-items-center" to='/' onClick={() => dispatch(_logout())}>
                      <Icon icon="solar:logout-2-outline" width={20} height={20} />
                      <span class="menu-item text-truncate">Log Out</span></Link></li>

                </ul></div> : null}
            
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

export default Sidebar
